import { useClientPortalAPI, useRequest } from "@certn/api";
import {
  Modal,
  Dialog,
  DialogHeader,
  DialogContent,
  DialogFooter,
  BasicButton,
  Text,
  DangerButton,
} from "@certn/cascadia-react";
import { useTranslation, Trans } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  tagName: string;
  id: string;
}

export function DeactivateTagModal(props: Props) {
  const { t } = useTranslation();
  const { isOpen, onClose, tagName, id } = props;

  const request = useRequest();
  const { mutate } = useClientPortalAPI(`/api/internal/client-portal/tags/`);

  async function deactivateTag(): Promise<void> {
    await request(`/api/internal/client-portal/tags/${id}/deactivate/`, {
      method: "POST",
    });
    mutate();
    onClose();
  }
  return (
    <Modal isOpen={isOpen}>
      <Dialog>
        <DialogHeader onClose={onClose}>{t("Deactivate tag?")}</DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            <Trans>
              By clicking “Deactivate”, the {{ tagName }} label will be removed
              from all groups, persons or packages.
            </Trans>
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton testID="cancel" onPress={onClose}>
            {t("Cancel")}
          </BasicButton>
          <DangerButton testID="deactivate-tag" onPress={() => deactivateTag()}>
            {t("Deactivate tag")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
